shouldResubscribe